import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-create-document-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule
  ],
  template: `
    <h2 mat-dialog-title>Criar Novo Documento</h2>
    <mat-dialog-content>
      <form [formGroup]="documentForm" class="form-container">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Título</mat-label>
          <input matInput placeholder="Título" formControlName="titulo">
          <mat-error *ngIf="documentForm.get('titulo')?.hasError('required')">
            Título é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Descrição</mat-label>
          <textarea matInput placeholder="Descrição" formControlName="descricao" rows="4"></textarea>
          <mat-error *ngIf="documentForm.get('descricao')?.hasError('required')">
            Descrição é obrigatória
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Tipo de Documento</mat-label>
          <mat-select placeholder="Tipo de Documento" formControlName="tipoDocumento">
            <mat-option *ngFor="let tipo of tiposDocumento" [value]="tipo">{{tipo}}</mat-option>
          </mat-select>
          <mat-error *ngIf="documentForm.get('tipoDocumento')?.hasError('required')">
            Tipo de documento é obrigatório
          </mat-error>
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancelar</button>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="documentForm.invalid">
        Criar
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .form-container {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px;
    }
    .full-width {
      width: 100%;
    }
  `]
})
export class CreateDocumentDialogComponent {
  documentForm: FormGroup;
  tiposDocumento = ['Comunicado', 'Documento', 'Relatório']; // Add more types as needed

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateDocumentDialogComponent>
  ) {
    this.documentForm = this.fb.group({
      titulo: ['', Validators.required],
      descricao: ['', Validators.required],
      tipoDocumento: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.documentForm.valid) {
      this.dialogRef.close(this.documentForm.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}